import './App.css';
import './helpers/Utilities';

import React from 'react';
import HttpsRedirect from 'react-https-redirect';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory as History } from 'history';
import { AuthRoute } from './helpers/AuthRoute';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { Page404, Page500, Page401 } from './views/ErrorPages';
import { Catch } from './helpers/Catch';

import {
  Home,
  Login,
  Withdrawal,
  Deposit,
  InternalTransfer,
  UserAccounts,
  AccountHistory,
  MyDocuments,
  Research,
  BankAccount,
  Campaign
} from './views';

import {
  QrCode,
  CommunityBank,
  CreditCard,
  Neteller,
  BtcPay,
  FastPay,
  Skrill,
  FlashPayDeposit,
  ZotaPay,
  ZotaPayQrCode
} from './views/Deposit/PSP';

import {
  NetellerWithdrawal, SkrillWithdrawal, BtcPayWithdrawal, FlashPay, UnionPayWithdrawal, BankAccountWithdrawal, UnipaymentWithdrawal
} from './views/Withdrawal/PSP';
import { Verification } from './views/Withdrawal/Verification';
import { ZotaPayWithdrawal } from './views/Withdrawal/PSP/ZotaPay';
import { TPayWithdrawal } from './views/Withdrawal/PSP/TPay';
import { TPayTRC20Withdrawal } from './views/Withdrawal/PSP/TPayTRC20';
import { TPay } from './views/Deposit/PSP/TPay';
import { TPayTRC20 } from './views/Deposit/PSP/TPayTRC20';
import { Unipayment } from './views/Deposit/PSP/UniPayment';
import { UnipaymentResult } from './views/Deposit/PSP/Unipayment/Result';

Catch();

function App() {
  return (
    <HttpsRedirect>
      <Router history={History()}>
        <LanguageProvider>
          <AuthProvider>
            <Switch>
              <Route exact path={"/Login"} component={Login} />
              <Route exact path={"/withdrawal/verification"} component={Verification} />

              <AuthRoute exact path={["/dashboard", "/home", "/"]} component={Home} />
              <AuthRoute exact path={"/withdrawal"} component={Withdrawal} />
              <AuthRoute exact path={"/deposit"} component={Deposit} />
              <AuthRoute exact path={"/bank-account"} component={BankAccount} />
              <AuthRoute path={"/internal-transfer"} component={InternalTransfer} />
              <AuthRoute path={"/user-accounts"} component={UserAccounts} />
              <AuthRoute path={"/account-history"} component={AccountHistory} />
              <AuthRoute path={"/my-documents"} component={MyDocuments} />
              <AuthRoute path={"/research"} component={Research} />
              <AuthRoute path={"/campaign"} component={Campaign} />

              {/* PROFILE */}
              {/* <AuthRoute path={"/settings"} component={Settings} /> */}

              {/* DEPOSIT */}
              <AuthRoute exact path={"/deposit/qrcode"} component={QrCode} />
              <AuthRoute exact path={"/deposit/communitybank"} component={CommunityBank} />
              <AuthRoute exact path={"/deposit/creditcard"} component={CreditCard} />
              <AuthRoute exact path={"/deposit/neteller"} component={Neteller} />
              <AuthRoute exact path={"/deposit/btcpay"} component={BtcPay} />
              <AuthRoute exact path={"/deposit/fastpay"} component={FastPay} />
              <AuthRoute exact path={"/deposit/skrill"} component={Skrill} />
              <AuthRoute exact path={"/deposit/flashpay"} component={FlashPayDeposit} />
              <AuthRoute exact path={"/deposit/zotapay"} component={ZotaPay} />
              <AuthRoute exact path={"/deposit/zotapayqrcode"} component={ZotaPayQrCode} />
              <AuthRoute exact path={"/deposit/tpay"} component={TPay} />
              <AuthRoute exact path={"/deposit/tpaytrc20"} component={TPayTRC20} />
              <AuthRoute exact path={"/deposit/unipayment"} component={Unipayment} />
              <AuthRoute exact path={"/deposit/unipayment/result"} component={UnipaymentResult} />

              {/* WITHDRAWAL */}
              <AuthRoute exact path={"/withdrawal/neteller"} component={NetellerWithdrawal} />
              <AuthRoute exact path={"/withdrawal/skrill"} component={SkrillWithdrawal} />
              <AuthRoute exact path={"/withdrawal/BtcPay"} component={BtcPayWithdrawal} />
              <AuthRoute exact path={"/withdrawal/FlashPay"} component={FlashPay} />
              <AuthRoute exact path={"/withdrawal/UnionPay"} component={UnionPayWithdrawal} />
              <AuthRoute exact path={"/withdrawal/bankaccount"} component={BankAccountWithdrawal} />
              <AuthRoute exact path={"/withdrawal/zotapay"} component={ZotaPayWithdrawal} />
              <AuthRoute exact path={"/withdrawal/tpay"} component={TPayWithdrawal} />
              <AuthRoute exact path={"/withdrawal/tpaytrc20"} component={TPayTRC20Withdrawal} />
              <AuthRoute exact path={"/withdrawal/unipayment"} component={UnipaymentWithdrawal} />

              {/* 404 */}
              <Route exact path={"/500"} component={Page500} />
              <Route exact path={"/401"} component={Page401} />
              <Route component={Page404} />
            </Switch>
          </AuthProvider>
        </LanguageProvider>
      </Router>
    </HttpsRedirect>
  );
}

export default App;
